import { render, staticRenderFns } from "./OrderDistributionChart.vue?vue&type=template&id=c128d140&scoped=true"
import script from "./OrderDistributionChart.vue?vue&type=script&lang=js"
export * from "./OrderDistributionChart.vue?vue&type=script&lang=js"
import style0 from "./OrderDistributionChart.vue?vue&type=style&index=0&id=c128d140&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c128d140",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c128d140')) {
      api.createRecord('c128d140', component.options)
    } else {
      api.reload('c128d140', component.options)
    }
    module.hot.accept("./OrderDistributionChart.vue?vue&type=template&id=c128d140&scoped=true", function () {
      api.rerender('c128d140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/OrderDistributionChart.vue"
export default component.exports